// extracted by mini-css-extract-plugin
module.exports = {"root":"Empty-module__root--11B-d Container-module__container--1e9BV","image":"Empty-module__image--3_bXa","text":"Empty-module__text--2ntvb"};